import React from 'react'
import { Link } from 'react-router-dom'
import '../../styles/parchment-page.css'
import './ComingSoon.css'

export default function ComingSoon() {
  return (
    <div className="page parchment-scope coming-soon">
      <div className="coming-soon__vignette" />
      <div className="coming-soon__mist" />

      <section className="coming-soon__hero">
        <span className="page__eyebrow">忍界戦記 · Acceso anticipado</span>
        <h1 className="page__title coming-soon__title">Shinobis&apos; War</h1>
        <div className="coming-soon__divider" aria-hidden="true">
          <span />
          <strong>印</strong>
          <span />
        </div>
        <p className="coming-soon__subtitle">
          Los estandartes se alzan. Los clanes se preparan. El mundo se sostiene sobre el filo de una espada.
        </p>
      </section>

      <section className="page__panel coming-soon__panel">
        <h2 className="coming-soon__section-title">La Profecía</h2>
        <div className="coming-soon__lore-grid">
          <article className="coming-soon__lore">
            <h3>Clanes en tensión</h3>
            <p>La paz se desangra en las fronteras. Los juramentos de antaño se han vuelto ceniza. El odio, esa herencia que nunca muere, vuelve a alzar la cabeza.</p>
          </article>
          <article className="coming-soon__lore">
            <h3>Sellos despiertos</h3>
            <p>En los templos abandonados, las runas han comenzado a arder. No son llamas de luz: <i>son llamas de recuerdo</i>. Algo que fue sellado está despertando.</p>
          </article>
          <article className="coming-soon__lore">
            <h3>Primeros convocados</h3>
            <p>Tu nombre no está aquí por casualidad. No eres un espectador. Eres uno de los que escribirán las crónicas... o uno de los que las leerán desde el exilio.</p>
          </article>
        </div>
      </section>

      <section className="page__panel coming-soon__panel coming-soon__access">
        <h2 className="coming-soon__section-title">Acceso Anticipado</h2>
        <p className="coming-soon__access-copy">
          El portal solo se abre una vez.<br />
          <br />
          Si ya formas parte de los convocados, cruza ahora. Si no, espera a que las cenizas se asienten. Y así se cumplirá la profecía.</p>
        <div className="coming-soon__actions">
          <Link to="/entrar" className="coming-soon__button coming-soon__button--primary">
            Iniciar sesión
          </Link>
          <Link to="/registro" className="coming-soon__button">
            Registrarse con invitación
          </Link>
        </div>
      </section>

      <p className="coming-soon__footer-note">Crónicas en preparación · Era beta cerrada</p>
    </div>
  )
}
